import React from "react";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CONFIG from "../../../utils/config";
import _ from "lodash";

import {
  ProductCardPriceInfo,
  SessionKeys,
  convertTimeFormat,
  getProcureInfo,
  goToLPDetailUtil,
} from "../../../utils/AppUtils";
import { useNavigate } from "react-router";
import CommonComponentEntity from "./CommonComponentEntity";
import {
  getLPsWithSubscription,
  getLPsWithSubscriptionClear,
} from "../../../redux/learningPath/actions";
import { useTranslation } from "react-i18next";

const LpIncludedWithSubscription = ({ currentSubscription }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const lpIncludedWithSubscriptionResponse = useSelector(
    (state) => state.learningPath.lpsIncludedWithSubscription
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getLpsWithSubscriptionData();

    return () => {
      dispatch(getLPsWithSubscriptionClear());
    };
  }, []);

  const [newCardData, setNewCardData] = useState(
    CONFIG.INITIAL_PRODUCT_CARD_DATA
  );

  const [paidUserCount, setPaidUserCount] = useState(0);

  const goToLPDetail = (lpInfo) => {
    let paramsReq ={
      lp_id: lpInfo.id,
      is_level: "false",
      source: lpInfo?.origin,
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(
      `/lpDetail?c=${encodedUrl}`
    );
  };

  const formatProductCardDataForLP = (lpData) => {
    let lpArr = [];

    for (let lp of lpData) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      if (!_.isEmpty(lp.provider)) {
        tags.push(lp.provider.provider_display_name);
        logoURL = lp.provider.provider_img;
      }
      tags.push("Action Path");

      if (lp.course_count) {
        tags.push(`${lp.course_count} Course${lp.course_count > 1 ? "s" : ""}`);
      }
      if (lp.video_count) {
        tags.push(`${lp.video_count} Video${lp.video_count > 1 ? "s" : ""}`);
      }
      if (lp.level_count) {
        tags.push(`${lp.level_count} Level${lp.level_count > 1 ? "s" : ""}`);
      }
      if (lp.event_count) {
        tags.push(`${lp.event_count} Event${lp.event_count > 1 ? "s" : ""}`);
      }
      if (lp.duration) {
        tags.push(convertTimeFormat(lp.duration, true, t));
      }
      let priceInfo = getProcureInfo(lp.purchased_info);
      lp.priceInfo = priceInfo;
      lp.fromSub = true;
      lpArr.push({
        id: lp?.id,
        ecom_id: lp?.ecom_id ? lp?.ecom_id : lp?.wc_post_id,
        is_like: lp?.is_like ? lp?.is_like : false,
        is_bookmark: lp?.is_bookmark ? lp?.is_bookmark : false,
        is_wishlist: lp?.is_addtowishlist,
        dbId: lp?.list_id,
        productType: "learningpath",
        productOrigin: lp?.origin,
        title: lp.name,
        logoURL: logoURL,
        logoAlText: "LP",
        bannerURL: lp.thumbnail,
        tagsArray: tags,
        description: lp.description,
        duration: "",
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: false,
        showProgress: true,
        showBody: false,
        showFooter: true,
        progress: lp.learn_progress,
        btnTitle: btnTitle,
        btnAction: () => goToLPDetailUtil(lp,navigate),
        descAction: () => {},
        bannerAction: () => goToLPDetailUtil(lp,navigate),
        cardClassName: "",
        footerLineComp: !_.isEmpty(priceInfo)
          ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          : "",
        isLoading: false,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
      });
    }

    setNewCardData(lpArr);
  };

  useEffect(() => {
    if (!_.isEmpty(lpIncludedWithSubscriptionResponse)) {
      if (lpIncludedWithSubscriptionResponse.status === "success") {
        const list1 =
          lpIncludedWithSubscriptionResponse.payload.payload?.records;
        if (!_.isEmpty(list1)) {
            setPaidUserCount(
              lpIncludedWithSubscriptionResponse.payload.payload?.user_count
            );
          formatProductCardDataForLP(list1);
          setIsLoading(false);
        } else {
          setNewCardData([]);
          setIsLoading(false);
        }
      } else {
        setNewCardData([]);
        setIsLoading(false);
      }
    }
  }, [lpIncludedWithSubscriptionResponse]);

  const getLpsWithSubscriptionData = () => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    setIsLoading(true);
    dispatch(
      getLPsWithSubscription({
        module: "lpsWithSubscription",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            ? localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            : "",
        },
      })
    );
  };

  useEffect(() => {
    setNewCardData(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  }, []);

  return (
    <>
      <CommonComponentEntity
        newCardData={newCardData}
        heading={`Action Paths included with ${
          currentSubscription ? currentSubscription : ""
        } subscription`}
        subHeading={`👍🏻  ${paidUserCount < 10 ? 10 : paidUserCount}+ learners have subscribed`}
        viewAllAction={"/learn/learningpath"}
        type={"lp"}
      />
    </>
  );
};

export default LpIncludedWithSubscription;
